import React from 'react';
import { useTranslation } from 'react-i18next';
import { SocialIcon } from 'react-social-icons';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  ContactGrid,
  ContactCard,
  ContactCardIcon,
  ContactCardContent,
  ContactCardTitle,
  ContactCardDescription,
  ContactCardButton,
} from '../styles';

interface ContactProps {
  themeName: ThemeType;
}

const handleWhatsAppContact = () => {
  const phoneNumber = '905541256268';
  const message = encodeURIComponent('Merhaba, danışmanlık/freelance hizmetleriniz hakkında bilgi almak istiyorum.');
  window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
};

const handleEmailContact = () => {
  const email = 'contact@anilorhan.dev';
  const subject = encodeURIComponent('Danışmanlık/Freelance Hizmet Talebi');
  const body = encodeURIComponent('Merhaba,\n\nDanışmanlık/freelance hizmetleriniz hakkında bilgi almak istiyorum.');
  window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
};

const handleLinkedInContact = () => {
  window.open('https://www.linkedin.com/in/anılorhan/', '_blank');
};

const contactItems = [
  { network: 'whatsapp' as const, color: '#25D366', handler: handleWhatsAppContact, key: 'whatsapp' },
  { network: 'email' as const, color: '#D44638', handler: handleEmailContact, key: 'email' },
  { network: 'linkedin' as const, color: '#0A66C2', handler: handleLinkedInContact, key: 'linkedin' },
];

const Contact: React.FC<ContactProps> = ({ themeName }) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper id="contact" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ ./contact --reach-out</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('services.contact.title')}</SectionTitle>

      <ContactGrid>
        {contactItems.map(({ network, color, handler, key }) => (
          <ContactCard key={key} $themeName={themeName} $accentColor={color} onClick={handler}>
            <ContactCardIcon $accentColor={color}>
              <SocialIcon
                network={network}
                style={{ width: 80, height: 80 }}
                bgColor="transparent"
                fgColor={color}
              />
            </ContactCardIcon>
            <ContactCardContent>
              <ContactCardTitle $themeName={themeName}>
                {t(`services.contact.${key}.title`)}
              </ContactCardTitle>
              <ContactCardDescription $themeName={themeName}>
                {t(`services.contact.${key}.description`)}
              </ContactCardDescription>
              <ContactCardButton $accentColor={color}>
                {t(`services.contact.${key}.button`)}
              </ContactCardButton>
            </ContactCardContent>
          </ContactCard>
        ))}
      </ContactGrid>
    </SectionWrapper>
  );
};

export default Contact;
